import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Quote from "./pages/Quote";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import AutoMilano from "./pages/AutoMilano";
import Casa from "./pages/Casa";
import RcProfessionale from "./pages/RcProfessionale";
import Vita from "./pages/Vita";
import InfortuniMalattia from "./pages/InfortuniMalattia";
import Monopattino from "./pages/Monopattino";
import CaniGatti from "./pages/CaniGatti";
import Soluzioni from "./pages/Soluzioni";
import Compliance from "./pages/Compliance";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/preventivo" element={<Quote />} />
            <Route path="/assicurazione-auto-milano" element={<AutoMilano />} />
            <Route path="/assicurazione-casa" element={<Casa />} />
            <Route path="/rc-professionale" element={<RcProfessionale />} />
            <Route path="/polizza-vita" element={<Vita />} />
            <Route path="/infortuni-malattia" element={<InfortuniMalattia />} />
            <Route path="/assicurazione-monopattino" element={<Monopattino />} />
            <Route path="/assicurazione-cani-gatti" element={<CaniGatti />} />
            <Route path="/soluzioni" element={<Soluzioni />} />
            <Route path="/compliance" element={<Compliance />} />
            {/* URL alternativi → redirect verso quelli canonici */}
            <Route path="/assicurazione-monopattino-elettrico" element={<Navigate to="/assicurazione-monopattino" replace />} />
            <Route path="/assicurazione-moto-milano" element={<Navigate to="/preventivo?type=moto" replace />} />
            <Route path="/assicurazione-viaggi" element={<Navigate to="/preventivo?type=viaggi" replace />} />
            {/* 301 SEO redirect dalla vecchia URL */}
            <Route path="/polizza-infortuni-malattia" element={<Navigate to="/infortuni-malattia" replace />} />
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
